module.exports = __webpack_public_path__ + "img/android.2f4dc931.png";